import { Paper } from "@mantine/core";
import { inventoryApi } from "apis/inventoryApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { InventoryResponseType } from "constants/types/inventory";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Inventory/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import InventoryFormFields from "../InventoryFormFields/InventoryFormFields";
import { editValidationSchema } from "./config";

interface EditFormProps {
  inventory: InventoryResponseType;
  onClose?: () => void;
  mutate?: () => void;
}

const EditForm: FC<EditFormProps> = ({ inventory, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      quantity: inventory.quantity,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await inventoryApi.update(inventory.id, values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật tồn kho thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Cập nhật tồn kho thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <InventoryFormFields formik={formik} />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
